module.exports = __webpack_public_path__ + "static/media/close.59bf837b.svg";